import type { ReactNode } from "react";

export type BadgeVariant = "default" | "success" | "warning" | "destructive" | "info" | "accent";
export type BadgeSize = "sm" | "md";

interface BadgeProps {
  variant?: BadgeVariant;
  size?: BadgeSize;
  children?: ReactNode;
  className?: string;
}

const variants: Record<BadgeVariant, string> = {
  default: "bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
  success: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
  warning: "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  destructive: "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300",
  info: "bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300",
  accent: "bg-accent text-accent-fg",
};

const sizes: Record<BadgeSize, string> = {
  sm: "text-[10px] px-1.5 h-4 leading-none",
  md: "text-xs px-2 h-5 leading-none",
};

export const Badge = ({
  variant = "default",
  size = "md",
  children,
  className = "",
}: BadgeProps) => {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-medium ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </span>
  );
};
